import { useEffect, useState } from "react";
import { recentActivities } from "../../../mocks/dashboard";
import { getStoredActivities, ActivityEntry } from "../../../lib/activityLog";

const typeIcon: Record<string, string> = {
  mail: "ri-mail-line",
  approval: "ri-file-list-3-line",
  chart: "ri-bar-chart-line",
  task_complete: "ri-checkbox-circle-line",
  event: "ri-flashlight-line",
};

const typeColor: Record<string, string> = {
  mail: "text-[#444444]",
  approval: "text-[#4B6CF7]/60",
  chart: "text-emerald-500/60",
  task_complete: "text-emerald-400/80",
  event: "text-amber-400/70",
};

export default function RecentActivity() {
  const [stored, setStored] = useState<ActivityEntry[]>([]);

  useEffect(() => {
    setStored(getStoredActivities());
    const id = setInterval(() => setStored(getStoredActivities()), 3000);
    return () => clearInterval(id);
  }, []);

  const combined = [
    ...stored.map(a => ({ id: a.id, time: a.time, text: a.text, type: a.type, isNew: true })),
    ...recentActivities.map(a => ({ ...a, isNew: false })),
  ].slice(0, 12);

  return (
    <div className="bg-[#111112] border border-white/[0.05] rounded-xl p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-[#888888] text-xs font-medium uppercase tracking-widest">최근 활동</h3>
        {stored.length > 0 && (
          <span className="text-[10px] text-emerald-400/70 flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400/70 inline-block animate-pulse"></span>
            방금 업데이트
          </span>
        )}
      </div>
      <div className="space-y-0 flex-1 overflow-y-auto">
        {combined.map((a, idx) => (
          <div key={a.id} className="flex gap-3 py-2.5 relative">
            {idx < combined.length - 1 && (
              <div className="absolute left-[13px] top-8 bottom-0 w-px bg-white/[0.04]" />
            )}
            <div className={`w-6 h-6 flex items-center justify-center rounded-lg shrink-0 z-10 ${
              "isNew" in a && a.isNew ? "bg-emerald-400/10 border border-emerald-400/20" : "bg-white/[0.04]"
            }`}>
              <i className={`${typeIcon[a.type] ?? "ri-circle-line"} text-xs ${typeColor[a.type] ?? "text-[#444444]"}`}></i>
            </div>
            <div className="flex-1 min-w-0 pt-0.5">
              <p className={`text-[11px] leading-relaxed ${"isNew" in a && a.isNew ? "text-[#AAAAAA]" : "text-[#777777]"}`}>{a.text}</p>
              <span className="text-[#555555] text-[10px]">{a.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
